import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overlay-loading-page" }
const _hoisted_2 = { class: "text-loading mt-3" }

import { VueSpinnerDots } from "vue3-spinners";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomSizeLoading',
  props: {
  text: {
    type: String,
    default: "Loading...",
  },
  size: {
    type: Number,
    default: 100,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VueSpinnerDots), {
      size: __props.size,
      color: "black"
    }, null, 8, ["size"]),
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.text), 1)
  ]))
}
}

})